import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import Approach from "@/pages/Approach";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import Consultant from "@/pages/Consultant";
import ChatWidget from "@/components/ChatWidget";

const CONSULTANT_SLUGS = [
  "ai-growth-marketing-consultant",
  "ai-marketing-consultant",
  "performance-marketing-consultant",
  "google-ads-consultant",
  "meta-ads-consultant",
  "cro-consultant",
  "marketing-automation-consultant",
];

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  // Admin route renders standalone (no site chrome)
  if (pathname.startsWith("/admin")) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster richColors position="bottom-right" />
      </>
    );
  }
  // Navbar variant based on route landing background
  const isDark = pathname === "/" || pathname === "/contact";
  return (
    <>
      <Navbar variant={isDark ? "dark" : "light"} />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/work" element={<Work />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/about" element={<About />} />
          <Route path="/approach" element={<Approach />} />
          <Route path="/contact" element={<Contact />} />
          {CONSULTANT_SLUGS.map((s) => (
            <Route key={s} path={`/${s}`} element={<Consultant />} />
          ))}
        </Routes>
      </main>
      <Footer />
      <ChatWidget />
      <Toaster richColors position="top-right" />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
